module.exports = "/assets/data/1fa3462ca0ffc596b303ec24f7f39c62-YO7.data.json";